const $$splitComponentImporter = () => import('/src/src/routes/_authenticated/_feature_announcement/_user/events/index.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from "@tanstack/react-router";
import { defineMessage } from "react-intl";
import { zodValidator } from "@tanstack/zod-adapter";
import { z } from "zod";
export const Route = createFileRoute("/_authenticated/_feature_announcement/_user/events/")({
  component: lazyRouteComponent($$splitComponentImporter, 'component'),
  validateSearch: zodValidator(z.object({
    page: z.number().int().optional(),
    pageSize: z.number().int().optional()
  })),
  staticData: {
    pageTitle: defineMessage({
      defaultMessage: "Events",
      description: "Page title"
    })
  }
});